import {NgModule} from "@angular/core";
import {NotificationChromeControlComponent} from "./notification-chrome-control/notification-chrome-control.component";
import {SharedModule} from "../shared/shared.module";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NotificationChromeControlComponent
    ],
    exports: [
        NotificationChromeControlComponent
    ]
})
export class NotificationModule {

}
